"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TravelGuides;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MAX_NUMBER_OF_CARDS = 2;
function TravelGuides(_ref) {
  var {
    data,
    baseDataTestId
  } = _ref;
  var sortedCards = data === null || data === void 0 ? void 0 : data.sort((a, b) => {
    var _a$order, _b$order;
    return ((_a$order = a.order) !== null && _a$order !== void 0 ? _a$order : 0) - ((_b$order = b.order) !== null && _b$order !== void 0 ? _b$order : 0);
  });
  return (0, _jsxRuntime.jsx)(_react.Flex, _objectSpread(_objectSpread({
    "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Wrapper')
  }, travelGuidesContainerStyles), {}, {
    w: data.length < MAX_NUMBER_OF_CARDS ? {
      mobile: 'full',
      sm: '34rem',
      md: '46rem',
      lg: '38.25rem',
      xl: '40.125rem'
    } : undefined,
    children: sortedCards === null || sortedCards === void 0 ? void 0 : sortedCards.map(item => {
      var _item$picture;
      return (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({
        "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Card')
      }, cardStyles), {}, {
        children: [(0, _jsxRuntime.jsxs)(_react.Flex, {
          justifyContent: "space-between",
          flexDirection: "column",
          children: [(0, _jsxRuntime.jsxs)(_react.Box, {
            children: [(0, _jsxRuntime.jsx)(_react.Heading, _objectSpread(_objectSpread({
              as: "h4",
              "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Title')
            }, titleStyles), {}, {
              children: item.title
            })), (0, _jsxRuntime.jsx)(_react.Text, {
              "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Description'),
              children: item.description
            })]
          }), (0, _jsxRuntime.jsx)(_atoms.Button, _objectSpread(_objectSpread({
            variant: "primary",
            size: "sm",
            formTarget: item.linkTarget,
            "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Button'),
            onClick: () => {
              var _item$linkUrl;
              window.location.href = (_item$linkUrl = item.linkUrl) !== null && _item$linkUrl !== void 0 ? _item$linkUrl : '';
            }
          }, buttonStyles), {}, {
            children: item.linkText
          }))]
        }), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, imageStyles), {}, {
          "data-testid": (0, _utils.formatDataTestId)(baseDataTestId, 'Image'),
          children: (0, _jsxRuntime.jsx)(_react.Image, {
            src: (0, _utils.formatAssetsUrl)((_item$picture = item.picture) !== null && _item$picture !== void 0 ? _item$picture : ''),
            borderTopRadius: "base"
          })
        }))]
      }), item.title);
    })
  }));
}
var travelGuidesContainerStyles = {
  flexDirection: {
    mobile: 'column',
    lg: 'row'
  },
  mb: '2xl',
  gap: 'lg',
  minH: {
    mobile: '292px',
    lg: '0'
  }
};
var cardStyles = {
  flexDirection: {
    mobile: 'column-reverse',
    sm: 'row'
  },
  borderWidth: '1px',
  borderRadius: 'lg',
  borderColor: 'var(--chakra-colors-lightGrey4)',
  padding: {
    mobile: 'md',
    lg: 'var(--chakra-space-md) var(--chakra-space-lg)'
  },
  gap: 'lg'
};
var titleStyles = {
  color: 'tertiary',
  fontSize: 'var(--chakra-fontSizes-3xxl)',
  fontFamily: 'var(--chakra-fonts-header)',
  fontWeight: 'var(--chakra-fontWeights-black)',
  lineHeight: {
    mobile: '2.75rem'
  },
  mb: {
    mobile: 0,
    lg: 'md'
  },
  mt: {
    mobile: '0',
    lg: 'md'
  }
};
var buttonStyles = {
  padding: 'var(--chakra-space-sm) var(--chakra-space-md)',
  mb: 'md',
  w: 'full',
  h: 'var(--chakra-space-10)',
  mt: {
    mobile: 'md',
    lg: '0'
  }
};
var imageStyles = {
  minW: {
    mobile: '16rem',
    sm: '13.563rem',
    md: '18.313rem'
  },
  minH: {
    mobile: '13.75rem',
    sm: '15.375rem',
    md: '16.25rem'
  },
  bgColor: 'lightGrey4',
  borderRadius: 'base'
};